/**
 * ROUND8: a dog's own fields at spawn (`Enemy.dog`, `Enemy.handlerId`). A leaf, so `create.ts` can call it without
 * pulling the dog's step - and everything that imports - into the creation of every soldier.
 */

import type { DogState, Enemy, SpawnDef } from '../../types';

/** A dog as it is put on the map: at heel, on no trail, with a bark ready. */
export function freshDogState(): DogState {
  return { mode: 'heel', trailTick: -1, barkTicks: 0 };
}

/**
 * The dog-only fields of a new `Enemy`. `handlerId` is the contract's 1000 + index, right whenever no dormant spawn
 * comes before the handler in the list; the dog's first tick checks it against the world and corrects it
 * (`bindHandler` in ./dog.ts), which is what `handlerSpawn` is kept for.
 */
export function dogFields(spawn: SpawnDef): Pick<Enemy, 'handlerId' | 'dog'> {
  const dog = freshDogState();
  if (spawn.handler === undefined) return { dog };
  dog.handlerSpawn = spawn.handler;
  return { handlerId: 1000 + spawn.handler, dog };
}
